import {useSelector} from 'react-redux';
import {sessionSelector} from 'store/auth/sessionSlice';

export const useTenantSettingHelper = () => {
    const {tenantSettings} = useSelector(sessionSelector);
    const isSettingEnabled = (value: string[]): boolean => {
        if (value.length === 0) {
            return true;
        }
        return tenantSettings?.some(setting => value.some(x => x === setting.uniqueId && setting.value?.booleanValue));
    };

    return {
        isSettingEnabled,
    };
};
